<span>Berlaku Hingga {{countdown$ | async}}</span>